// import { ASSETS_LINK } from '@constant';
// import useThemeStore from '@hooks/zustand/Theme/useThemeStore';
import VideoPlayer from "@/components/modules/VideoPlayer";
import useThemeStore from "@/shared/store/useThemeStore";
import { getContent } from "@/shared/utils/content.utils";
import { THEMES } from "@shared-types/themes";

import React, { useEffect, useMemo, useRef, useState } from "react";

const VideoPlayerComp = VideoPlayer as any;

export type TestimonialsDataFormat = {
  heading: string;
  highlights: Array<{ title: string; subtitle: string }>;
  videos: Array<{
    url: string;
    testimonial: string;
    name: string;
    position: string;
    thumbnail: string;
  }>;
  ratings: Array<{
    logo: string;
    rating: string;
  }>;
  testimonials: Array<{
    text: string;
    name: string;
    position: string;
    profileImage: string;
  }>;
};

type HomeTestimonialsProps = {
  data: TestimonialsDataFormat;
  langFile?: string;
};

const HomeTestimonials: React.FC<HomeTestimonialsProps> = ({
  data,
  langFile,
}) => {
  const [testimonial, setTestimonial] = useState(0);
  const increment = () => setTestimonial((i) => i + 1);

  const ref = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    startInterval();
    return () => stopInterval();
  }, []);

  const startInterval = () => {
    stopInterval();

    ref.current = setInterval(increment, 5000);
  };
  const stopInterval = () => {
    clearInterval(ref.current);
  };
  const currImageIndex = testimonial % data?.videos.length;

  const currVideo = data?.videos[currImageIndex];

  // const Translate = useTranslator(langFile);

  const settings = {
    centerMode: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    swipeToSlide: true,
    lazyLoad: true,
    cssEase: "linear",
    arrows: false,
  };
  const slider = useRef<any>();

  // const next = () => {
  //   slider.current?.slickNext();
  // };

  // const previous = () => {
  //   slider.current?.slickPrev();
  // };

  const { theme } = useThemeStore();

  const blockClasses = useMemo(() => {
    if (theme === THEMES["02"])
      return {
        heading:
          "mb-12 font-paralucent text-2xl md:text-4xl text-black text-center xl:text-left",
        highlightTitle: "text-black text-sapphire03 text-2xl mb-2 text-left",
        highlightSubtitle:
          "text-sapphire02 text-xxs sm:text-sm sm:leading-5 text-left",
        highlightsContainer:
          "flex flex-row text-center space-x-2 md:text-left md:space-y-0 mb-14 justify-center xl:justify-start",
      };
    return {
      heading:
        "mb-6 font-obviously font-bold text-2xl md:text-title-32 text-black text-center xl:text-left",
      highlightTitle: "text-black text-title-24 mb-2",
      highlightSubtitle: "text-slate02 text-sm leading-5",
      highlightsContainer:
        "flex md:flex-row flex-col text-center space-y-7 gap-4 md:text-left md:space-y-0 mb-12 justify-center xl:justify-start",
    };
  }, [theme]);

  const getHeading = useMemo(() => {
    const heading = data.heading;
    return getContent(heading);
  }, [data]);

  return (
    <div className="flex items-center justify-center text-center">
      <div className="container grid grid-cols-1 md:justify-items-center xl:grid-cols-2 xl:gap-32">
        <div className="relative w-full max-w-sm ">
          <div className="flex flex-col rounded-xl bg-purple-0 pb-5">
            <div className="flex flex-col justify-evenly gap-[20px]">
            <div key={currVideo.name}>
              <div className="rounded-2xl">
                <VideoPlayerComp
                  height="257px"
                  className="object-cover"
                  url={`https://d502jbuhuh9wk.cloudfront.net/${currVideo.url}`}
                  light={false}
                  isDefaultImage
                  isCard
                  thumbnail={currVideo.thumbnail}
                  stopInterval={stopInterval}
                  startInterval={startInterval}
                />
              </div>
             
              <div className="px-4">
                <h5 className="mb-6 mt-8 font-medium text-title-20">
                  {currVideo.testimonial}
                </h5>
              </div>
              </div>
              <div className="flex flex-row items-start justify-start gap-[8px] self-stretch px-4">
                {data?.videos.map((video, index) => {
                  return (
                    <div
                      key={"abc"}
                      className={`relative h-[5px] flex-1 rounded-xl ${
                        index === currImageIndex ? "bg-purple-3" : "bg-grey-0"
                      }`}
                    />
                  );
                })}
              </div>
            </div>
          </div>
         
        </div>
        <div className="mt-28 max-w-xl md:mt-10">
          <h3 className={blockClasses.heading}>{getHeading}</h3>
          <div className={blockClasses.highlightsContainer}>
            {data?.highlights?.map((highlight, index) => (
              <div key={highlight?.title} className="">
                <h4 className={blockClasses.highlightTitle}>
                  {highlight?.title}
                </h4>
                <h6 className={blockClasses.highlightSubtitle}>
                  {highlight?.subtitle}
                </h6>
              </div>
            ))}
          </div>
          <div className="flex flex-row items-center divide-slate04 xl:divide-x">
            {data.ratings?.map((company, index) => (
              <div
                className={`${
                  index === 0 ? "mr-2 md:mr-10" : "px-4 md:px-10"
                } flex-col`}
                key={company?.logo}
              >
                <img src={company?.logo} alt="company logo" className="mb-1" />
                <img
                  src={company?.rating}
                  alt="company rating"
                  className="mb-1"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeTestimonials;
